import { atom } from "jotai";

import { clientConfigAtom } from "atoms/clientConfig";
import { removeNumberSeparators } from "utils/stringHelper";

import { mileageAtom, mileagePhotoAtom } from "./mileage";
import { vehicleConditionQuestionsAtom } from "./questions";

export const isVehicleConditionValidAtom = atom((get) => {
  const mileage = get(mileageAtom);
  const answeredQuestions = get(vehicleConditionQuestionsAtom);
  const mileagePhoto = get(mileagePhotoAtom);
  const {
    vehicleCondition: { showMileage, showMileagePhoto, questions: vehicleConditionQuestions },
  } = get(clientConfigAtom);

  const validations = {
    ...(showMileage && {
      mileageHasValue: mileage !== "" && mileage !== "0" && +removeNumberSeparators(mileage) <= 3000000,
    }),
    ...(showMileagePhoto && { mileageHasPhoto: mileagePhoto.length > 0 }),
    questionsSelected: vehicleConditionQuestions?.every((question) => typeof answeredQuestions[question] === "boolean"),
  };

  return Object.values(validations).every((validation) => validation);
});
